import { Directive, ElementRef, HostListener, Renderer2, AfterViewInit } from '@angular/core';

@Directive({
    selector: '[appActiveLink]',
    standalone: false
})
export class ActiveLinkDirective implements AfterViewInit {
  sections: HTMLElement[] = [];
  navLinks: HTMLElement[] = [];
  isProgrammaticScroll = false;

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngAfterViewInit() {
    setTimeout(() => {
      this.initializeSectionsAndLinks();
      this.setupNavLinkClickHandlers();
    }, 0);
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    if (!this.isProgrammaticScroll) {
      this.setActiveLink();
    }
  }

  initializeSectionsAndLinks() {
    this.sections = Array.from(document.querySelectorAll('.heading.margin-bottom-4px'));
    this.navLinks = Array.from(this.el.nativeElement.querySelectorAll('.nav-panel-link')) as HTMLElement[];
  }

  setupNavLinkClickHandlers() {
    this.navLinks.forEach(link => {
      link.addEventListener('click', (event) => {
        this.isProgrammaticScroll = true;
        this.resetNavLinkStyles();
        this.highlightLink(event.currentTarget as HTMLElement);
        setTimeout(() => this.isProgrammaticScroll = false, 600);
      });
    });
  }

  resetNavLinkStyles() {
    this.navLinks.forEach(link => {
      this.renderer.removeStyle(link, 'background-color');
      this.renderer.removeStyle(link, 'color');
    });
  }

  highlightLink(link: HTMLElement) {
    this.renderer.setStyle(link, 'background-color', 'var(--sage-light)');
    this.renderer.setStyle(link, 'color', 'var(--forest)');
  }

  setActiveLink() {
    if (this.sections.length === 0) {
      this.initializeSectionsAndLinks();
    }
    for (const section of this.sections) {
      const rect = section.getBoundingClientRect();
      if (rect.top >= 0 && rect.top < window.innerHeight) {
        let sectionText = this.getSectionText(section);

        for (const link of this.navLinks) {
          const linkText = link.textContent?.trim();
          if (sectionText?.toLowerCase() === linkText?.toLowerCase()) {
            this.resetNavLinkStyles();
            this.highlightLink(link);
            return;
          }
        }
      }
    }
  }

  getSectionText(section: HTMLElement): string | undefined {
    let sectionText = section.textContent?.trim();

    if (sectionText === $localize`Reference coverage` || sectionText === $localize`Reference sentiment`) {
      return $localize`Summary`;
    } else if (sectionText === $localize`Unusual activity detected*`) {
      return $localize`Unusual activity`;
    }

    return sectionText;
  }
}
